<div
  class="icon"
  (click)="onClick()"
>
  <i class="fa-regular fa-info-circle"></i>
</div>
